import APIServiceLookUp from './serviceAPI';
import { API_URL, MAIN_API_URL } from './models/AppConstent';

export default class ServiceAuth {
    lookupService = new APIServiceLookUp();

    async userLogin(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}auth/loginPOSUser`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async userOrg(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}org/getOrgByUser`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async userOutlet(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}outlet/getOutletbyUser`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async userRABL(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}outlet/getRABLUser`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async userRefresh() {
        var serviceType = "POST";
        var url = `${API_URL}auth/refreshPOSUser`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, {}, '');
    }

    async updateName(body) {
        var serviceType = "POST";
        var url = `${API_URL}staff/updateName`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async updateEmail(body) {
        var serviceType = "POST";
        var url = `${API_URL}staff/updateEmail`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async updatePhone(body) {
        var serviceType = "POST";
        var url = `${API_URL}staff/updatePhone`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async disableAccount() {
        var serviceType = "POST";
        var url = `${API_URL}staff/disableAccount`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, {}, '');
    }

    async updatePassword() {
        var serviceType = "POST";
        var url = `${API_URL}staff/updatePassword`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, {}, '');
    }
}